<div class="ipm-order-help-support">
    <div class="ipm-header">
        <h3>{{headingText}}</h3>
         <div class="ipm-close-icon" (click)="closePopup()">
            <i class="pi pi-times"></i>
        </div>
    </div>
    <div class="ipm-custom-accordion" *ngIf="currentBeatData">
        <mat-accordion>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title class="ipm-header">
                        <span>{{orderType === 'studioOrder' ? 'Buyer Info' : 'Seller Info'}}</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="ipm-seller-details">
                    <div class="ipm-seller-profile">
                        <img priority
                            [src]="currentBeatData?.seller?.producer[0]?.profile_picture || './assets/imgs/icons/profile-image.svg'"
                            alt="seller-profile" class="ipm-seller-profile-img" width="48" height="48">
                    </div>
                    <div class="ipm-seller-info">
                        <div class="ipm-seller-name">{{ currentBeatData?.seller?.producer[0]?.store?.general?.name ||
                            currentOrderDetails?.buyer?.name || 'Seller Name' }}</div>
                        <div class="ipm-seller-email">
                            <span>{{ currentBeatData?.seller?.email || currentOrderDetails?.buyer?.email || 'N/A' }}</span>
                            <button class="ipm-copy-btn" *ngIf="(currentBeatData?.seller?.email || currentOrderDetails?.buyer?.email)"
                                (click)="copyEmailToClipboard(currentBeatData?.seller?.email || currentOrderDetails?.buyer?.email)"
                                type="button">
                                <i class="pi pi-copy"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
    <div class="ipm-list-wrapper">
        <ng-container *ngFor="let item of listOfOrdersSupport; let i = index">
            <!-- Disable the Distpute purchase on the basis of title and not index because when there is no dispute purchase other option at index 0 get disable -->
            <div class="ipm-list-of-options" (click)="openClickOption(item)" [class.ipm-disabled-option]="daysLeft === 0 && item.title === 'Dispute Purchase'"> 
                <div class="ipm-icon" [innerHTML]="item.icon | UiSafe : 'html'"></div>
                <div class="ipm-content-section w-100">
                    <div class="ipm-title">
                        <span>{{ item.title }}</span>
                        <ng-container *ngIf="daysLeft > 0 && i === 0 && orderType !== 'studioOrder'">
                            <span class="ipm-days-left">{{ daysLeft }} days left to raise a dispute</span>
                        </ng-container>
                    </div>
                    <div class="ipm-subtext">{{ item.subtext }}</div>
                </div>
            </div>
        </ng-container>
    </div>
</div>